import gql from 'graphql-tag';

export const MESSAGE_PROFILE = gql`
  mutation ($id: Int!, $message: Html!, $eventId: Int) {
    messageProfile(input: { id: $id, message: $message, eventId: $eventId }) {
      errors { message }
    }
  }
`;
